export default __webpack_public_path__ + "static/hipopener_1-72e891500abbc0258a6e09644b82e4c3.jpg";